module.exports = __webpack_public_path__ + "8cd6d323006ea11638ca2a755c81d105.glb";